export default __webpack_public_path__ + "static/media/k2.9e828a81.svg";